/** Fuzzy, accent-insensitive subsequence match with a simple score (§6.3 search, §6.1 lookup). */
export function normalize(s: string): string {
  return s
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '');
}

/** 0 = no match; higher is better. Prefers prefix and contiguous matches. */
export function fuzzyScore(query: string, text: string): number {
  if (!query) return 1;
  const q = normalize(query);
  const t = normalize(text);
  if (!t) return 0;
  const idx = t.indexOf(q);
  if (idx === 0) return 100;
  if (idx > 0) return 80 - Math.min(idx, 30);
  // subsequence
  let ti = 0;
  let score = 0;
  let streak = 0;
  for (const ch of q) {
    const found = t.indexOf(ch, ti);
    if (found < 0) return 0;
    streak = found === ti ? streak + 1 : 0;
    score += 1 + streak;
    ti = found + 1;
  }
  return Math.min(score, 50);
}

export function matchesAny(query: string, fields: (string | null | undefined)[]): number {
  let best = 0;
  for (const f of fields) if (f) best = Math.max(best, fuzzyScore(query, f));
  return best;
}
